import { render } from "./Pagination.vue?vue&type=template&id=c86474a2"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c86474a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c86474a2', __exports__)) {
    api.reload('c86474a2', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=c86474a2", () => {
    api.rerender('c86474a2', render)
  })

}


export default __exports__